<template>
  <div>
    <div class="container-fluid">
      <button
        type="button"
        style="top:90px;right:20px;z-index:20"
        @click="backToIndex"
        class="position-absolute btn btn-default m-0"
      >
        回上一頁
      </button>
      <div
        class="mb-3"
        :class="{ 'section-loading': infoLoading }"
        style="overflow: hidden;max-height: 148px;"
      >
        <div class="float-left w-75  pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              class="text-orange"
              style="text-decoration:none;"
            >
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>
            </a>
          </h4>
          <div class="mb-line" style="">
            <span class="font-weight-bold mr-2"
              >{{ categoryInfo.upload_date | dateFormat }} ~
              {{ categoryInfo.end_date | dateFormat }}</span
            >
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">{{
              categoryInfo.description
            }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class="">
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div class="mb-line" :class="{ 'section-loading': isLoading_btn }">
            <a
              class="btn btn-default m-0"
              @click="satisfactionModal"
              v-if="isBtnEnble"
              >滿意度調查</a
            >
            <a
              class="btn btn-default m-0"
              @click="alreadyDone"
              disabled="disabled"
              v-else
              >滿意度調查</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{ 'section-loading': subsLoading }">
      <div class="row">
        <section class="newTable">
          <table class="table datatable table-striped area-list-datatable">
            <thead>
              <tr>
                <th :width="screenWidth * 0.09">
                  <div class="checkbox checkbox-inline mr-0">
                    <input
                      type="checkbox"
                      :name="`substantial-check-all`"
                      :id="`substantial-check-all`"
                      v-model="checkAll"
                      @click="
                        clickTarget =
                          clickTarget == `clickAll`
                            ? `clickAll-again`
                            : `clickAll`
                      "
                    />
                    <label :for="`substantial-check-all`"></label>
                  </div>
                  <span>#</span>
                </th>
                <th
                  :width="screenWidth * 0.08"
                  class="sorting"
                  :class="
                    'sorting ' +
                      (order.fieldName == 'name'
                        ? order.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : '')
                  "
                  @click="columnSorting('name')"
                >
                  姓名
                </th>
                <th
                  :width="screenWidth * 0.09"
                  class="sorting"
                  :class="
                    'sorting ' +
                      (order.fieldName == 'ceapcno'
                        ? order.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : '')
                  "
                  @click="columnSorting('ceapcno')"
                >
                  身分證
                </th>
                <th
                  :width="screenWidth * 0.096"
                  class="sorting"
                  :class="
                    'sorting ' +
                      (order.fieldName == 'mobile'
                        ? order.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : '')
                  "
                  @click="columnSorting('mobile')"
                >
                  手機
                </th>
                <th
                  :width="screenWidth * 0.2"
                  class="sorting"
                  :class="
                    'sorting ' +
                      (order.fieldName == 'email'
                        ? order.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : '')
                  "
                  @click="columnSorting('email')"
                >
                  Email
                </th>
                <th
                  :width="screenWidth * 0.09"
                  class="sorting"
                  :class="
                    'sorting ' +
                      (order.fieldName == 'age'
                        ? order.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : '')
                  "
                  @click="columnSorting('age')"
                >
                  保險增齡提醒
                </th>
                <th
                  :width="screenWidth * 0.09"
                  class="sorting"
                  :class="
                    'sorting ' +
                      (order.fieldName == 'digital_contact_tag'
                        ? order.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : '')
                  "
                  @click="columnSorting('digital_contact_tag')"
                >
                  數位接觸頻率
                </th>
                <th
                  :width="screenWidth * 0.096"
                  class="sorting"
                  :class="'sorting ' + (order.fieldName == 'is_netinsr'? order.asc? 'sorting_asc' : 'sorting_desc': '')"
                  @click="columnSorting('is_netinsr')"
                >
                  網路投保資格
                </th>
                <th
                  width="*"
                  class="sorting"
                  :class="
                    'sorting ' +
                      (order.fieldName == 'time'
                        ? order.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : '')
                  "
                  @click="columnSorting('time')"
                >
                  邀請函發送狀態
                </th>
              </tr>
            </thead>
            <tbody :style="{ height: scrollHeight + 'px' }">
              <tr
                v-for="(item, index) in tableDataBackup"
                :key="`out-${index}`" :id="`out-${index}`"
              >
                <td :width="screenWidth * 0.09">
                  <div style="min-height: 30px;">
                    <div class="mr-0 checkbox checkbox-inline">
                      <input
                        @click="
                          clickTarget =
                            clickTarget == `td-${index}`
                              ? `td-${index}-again`
                              : `td-${index}`
                        "
                        type="checkbox"
                        name="`td-item[]`"
                        :id="`check-out-${index}`"
                        :value="item.ceapcno"
                        v-model="selection"
                        :disabled="item.ceapcno === ''"
                        @change="$emit('update', selection)"
                      />
                      <label :for="`check-out-${index}`"></label>
                    </div>
                    <span>
                      <span class="no">{{ index + 1 }}</span>
                      <span class="info text-center">
                        <level :lv="Number(item.vip_lv)" />
                        <avatar
                          :gender="Number(item.ceapcno.charAt(1))"
                          :size="20"
                        />
                      </span>
                    </span>
                  </div>
                </td>
                <td :width="screenWidth * 0.08">
                  <Tooltip
                    :position="index < 3 ? 'bottom' : 'top'"
                    :name="item.name"
                    :id="item.ceapcno"
                    :mobile="item.mobile"
                  >
                    <a
                      v-if="item.is_exist"
                      @click.prevent="routerToCust(item.ceapcno, item.name)"
                      class="link text-underline"
                      >{{ item.name | getMaskName }}</a
                    >
                    <a v-else>{{ item.name | getMaskName }}</a>
                  </Tooltip>
                </td>
                <td :width="screenWidth * 0.09">
                  <span>{{ item.ceapcno | getMaskID }}</span>
                </td>
                <td :width="screenWidth * 0.096">
                  {{ item.mobile | getMaskMobile }}
                </td>
                <td :width="screenWidth * 0.2">{{ item.email }}</td>
                <td :width="screenWidth * 0.09">
                  {{ item.age }}<br /><span style="color:red;">{{
                    item.memo
                  }}</span>
                </td>
                <td :width="screenWidth * 0.09">
                  {{ item.digital_contact_tag }}
                </td>
                <td :width="screenWidth * 0.096" v-if="item.is_netinsr == 'Y'">
                  已開通
                </td>
                <td :width="screenWidth * 0.096" v-else>未開通</td>
                <td
                  width="*"
                  v-if="item.time == item.sms_open_time"
                >
                  {{ item.time | dateFormat }}<br />{{ item.sms_open_status }}
                </td>
                <td
                  width="*"
                  v-else-if="item.time == item.email_open_time"
                >
                  {{ item.time | dateFormat }}<br />{{ item.email_open_status }}
                </td>
                <td width="*" v-else-if="item.sms_open_time == ''">
                  {{ item.time | dateFormat }}<br />{{ item.email_open_status }}
                </td>
                <td width="*" v-else-if="item.email_open_time == ''">
                  {{ item.time | dateFormat }}<br />{{ item.sms_open_status }}
                </td>
                <td width="*" v-else>
                  {{ item.time | dateFormat }}
                </td>
              </tr>
              <tr v-if="tableDataBackup.length == 0">
                <td colspan="8" class="text-center pt-3 pb-5">
                  <h3>
                    無客戶名單資料
                  </h3>
                </td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row align-item-center align-content-center">
        <div class="col-12"></div>
        <div class="col-6 col-sm-6 col-md-6"></div>
        <div class="col-6 col-sm-6 col-md-6 text-right">
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="openInvitationModal()"
            :disabled="!selection.length"
            :custs="selection"
          >
            發送邀請函
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >
            加入群組
          </button>
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >
            列印名條
          </button>
        </div>
      </div>
    </section>

    <!-- 發送邀請函-->
    <invitation-modal
      :open="InvitationModalOpen"
      :custs="selection"
      @close="CloseInvitation()"
    />

    <!-- 保戶通聯查詢 -->
    <integrated-address-modal
      :open="IntegratedAddressModalOpen"
      :address-data="addressData"
      @close="panelClose('IntegratedAddressModalOpen')"
    />

    <!-- 失聯回報 -->
    <missing-modal
      :open="MissingModalOpen"
      :contact="missingContact"
      @submit="updateMissing"
      @close="panelClose('MissingModalOpen')"
    />

    <!-- 列印名條 -->
    <print-modal
      :open="printModalOpen"
      :custs="selection"
      @close="panelClose('printModalOpen')"
    />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import InvitationModal from "../InvitationModal";
import IntegratedAddressModal from "../IntegratedAddressModal";
import MissingModal from "../MissingModal";
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import SatisfactionModal from "../SatisfactionModal";
import Tooltip from "@/desktop/components/ToolTip";
import moment from "moment";
import { downloadFile_m0 } from '@/service';
import { saveAs } from 'file-saver'
import {
  getIonlyU,
  getChangeReprot,
  getChangeUpdateReprot,
  queryBelowEstrangePolicyContactInfo,
  getCategoryDetail,
  isSatisfactionSurveyFinish,
} from "@/service";
import $ from "jquery";

export default {
  name: "iOnlyU",
  mixins: [commonMixin],
  components: {
    PrintModal,
    InvitationModal,
    IntegratedAddressModal,
    MissingModal,
    Level,
    Avatar,
    GroupModal,
    SatisfactionModal,
    Tooltip
  },
  watch: {
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.distinctid.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.distinctid.length;
      }
      this.$emit("update", this.selection);
    }
  },
  props: {
    status: String
  },
  filters: {},
  data() {
    //data block layout
    return {
      subsLoading: false,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      isBtnEnble: true,
      isLoading_btn: false,
      sendType: "send",
      categoryInfo: {},
      currentPage: 0,
      totalpages: 0,
      tableData: [],
      tableDataBackup: [],
      visitList: [],
      allIdData: [],
      distinctid: [],
      clickTarget: "",
      checkAllClick: false,
      checkAll: false,
      addPageStatus: false,
      remoteDataMsg: "資料讀取中，請稍候...",
      selection: [],
      InvitationModalOpen: false,
      IntegratedAddressModalOpen: false,
      message: "",
      MissingModalOpen: false,
      title: "",
      screenWidth:
        document.body.clientWidth > 1208 ? 1280 : document.body.clientWidth,
      scrollHeight: 0,
      order: {
        fieldName: "ceapcnm",
        asc: true
      },
      addressData: {},
      missingContact: "",
      missVisit: "",
      missCustId: "",
      sendCustData: {},
      satisfactionModalOpen: false,
      currentRecord: {}
    };
  },
  computed: {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
     //判斷是否為box
     return this.UserInfo.userType === 'box'
    }
  },
  methods: {
    ...mapActions([
      "setPageLock",
      "updateCustInfo",
      "updateCustID",
      "updateSerNo"
    ]),
    initCustList() {
      // 初始化
      this.subsLoading = true;
      this.checkAll = false;
      this.selection = [];
      this.getData(0);
      // 取得專區資訊
      this.getTitleInfo();

      // 確認滿意度
      this.checkIsSatisfactionSurveyFinish();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status === "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "time":
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.dateCompareFun(sortOrder, fieldName)
            );
            this.allIdData = this.tableDataBackup.map(ele => {
              return ele.ceapcno;
            });
            this.distinctid = this.allIdData.filter(function(
              element,
              index,
              arr
            ) {
              return arr.indexOf(element) === index;
            });
            this.registerHanlink(); // 難字顯示
            if (this.checkAll) {
              this.selection = [];
              this.distinctid.forEach(data => {
                this.selection.push(data);
              });
              this.$emit("update", this.selection);
            }
          }, 20);
          break;
        case "name":
          this.tableDataBackup = [];
          this.getData(sortOrder);
          break;
        case "email":
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.emialCompareFun(sortOrder, fieldName)
            );
            this.allIdData = this.tableDataBackup.map(ele => {
              return ele.ceapcno;
            });
            this.distinctid = this.allIdData.filter(function(
              element,
              index,
              arr
            ) {
              return arr.indexOf(element) === index;
            });
            this.registerHanlink(); // 難字顯示
            if (this.checkAll) {
              this.selection = [];
              this.distinctid.forEach(data => {
                this.selection.push(data);
              });
              this.$emit("update", this.selection);
            }
          }, 20);
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.allIdData = this.tableDataBackup.map(ele => {
              return ele.ceapcno;
            });
            this.distinctid = this.allIdData.filter(function(
              element,
              index,
              arr
            ) {
              return arr.indexOf(element) === index;
            });
            this.registerHanlink(); // 難字顯示
            if (this.checkAll) {
              this.selection = [];
              this.distinctid.forEach(data => {
                this.selection.push(data);
              });
              this.$emit("update", this.selection);
            }
          }, 20);
      }
    },
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    emialCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property].toLowerCase() < b[property].toLowerCase() ? -1 : a[property].toLowerCase() > b[property].toLowerCase() ? 1 : 0;
        return result * sortOrder;
      };
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.isBtnEnble = result.body.isfinish === "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    formatEmail(str) {
      //email的狀態對照碼
      let result = "";
      if (str == "-2") {
        result = "MailHunter:重複E-Mail";
      } else if (str == "-1") {
        result = "BillHunter:抽件 MailHunter:黑名單";
      } else if (str == "0") {
        result = "寄送成功";
      } else if (str == "1") {
        result = "郵件地址錯誤";
      } else if (str == "2") {
        result = "信箱空間不足";
      } else if (str == "3") {
        result = "無此使用者";
      } else if (str == "4") {
        result = "IP被封鎖";
      } else if (str == "5") {
        result = "逾時終止";
      } else if (str == "6") {
        result = "系統驗證錯誤";
      } else if (str == "7") {
        result = "使用者中斷";
      } else if (str == "8") {
        result = "退信失敗";
      } else if (str == "9") {
        result = "組信失敗";
      } else if (str == "21") {
        result = "寄送中";
      } else if (str == "open") {
        result = "信件已讀取";
      }

      return result;
    },
    formatMsg(str) {
      //Msg的狀態對照碼
      let result = "";
      if (str == "0") {
        result = "預約傳送中 ";
      } else if (str == "1") {
        result = "已送達業者 ";
      } else if (str == "2") {
        result = "已送達業者";
      } else if (str == "3") {
        result = "已送達業者 ";
      } else if (str == "4") {
        result = "已送達手機 ";
      } else if (str == "5") {
        result = "內容有錯誤 ";
      } else if (str == "6") {
        result = "門號有錯誤";
      } else if (str == "7") {
        result = "簡訊已停用";
      } else if (str == "8") {
        result = "逾時無送達";
      } else if (str == "9") {
        result = "預約已取消";
      } else if (str == "A") {
        result = "已推播";
      } else if (str == "R") {
        result = "推播未讀改發簡訊";
      } else if (str == "B") {
        result = "即時簡訊、OTP驗證簡訊備份 ";
      } else if (str == "L") {
        result = "LINE BC已推播 ";
      } else if (str == "*") {
        result = "系統發送錯誤，請聯絡三竹資訊窗口人員 ";
      } else if (str == "a") {
        result = "簡訊發送功能暫時停止服務，請稍候再試";
      } else if (str == "b") {
        result = "簡訊發送功能暫時停止服務，請稍候再試";
      } else if (str == "c") {
        result = "請輸入帳號";
      } else if (str == "d") {
        result = "請輸入密碼";
      } else if (str == "e") {
        result = "帳號、密碼錯誤 ";
      } else if (str == "f") {
        result = "帳號已過期";
      } else if (str == "h") {
        result = "帳號已被停用";
      } else if (str == "k") {
        result = "無效的連線位址";
      } else if (str == "l") {
        result = "帳號已達到同時連線數上限";
      } else if (str == "m") {
        result = "必須變更密碼，在變更密碼前，無法使用簡訊發送服務";
      } else if (str == "n") {
        result = "密碼已逾期，在變更密碼前，將無法使用簡訊發送服務 ";
      } else if (str == "p") {
        result = "沒有權限使用外部Http程式";
      } else if (str == "r") {
        result = "系統暫停服務，請稍後再試 ";
      } else if (str == "s") {
        result = "帳務處理失敗，無法發送簡訊 ";
      } else if (str == "t") {
        result = "簡訊已過期";
      } else if (str == "u") {
        result = "簡訊內容不得為空";
      } else if (str == "v") {
        result = "無效的手機號碼 ";
      } else if (str == "w") {
        result = "查詢筆數超過上限 ";
      } else if (str == "x") {
        result = "發送檔案過大，無法發送簡訊 ";
      } else if (str == "y") {
        result = "參數錯誤 ";
      } else if (str == "z") {
        result = "查無資料";
      }

      return result;
    },
    updateSelection(val) {
      this.selection = val;
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_PRECISION_MARKETING_LIST");
    },
    openAddressModal(custId, custName) {
      //  打開保戶通聯
      this.subsLoading = true;
      queryBelowEstrangePolicyContactInfo(
        this.$store.state.userInfo.id,
        custId,
        custName
      ).then(result => {
        this.subsLoading = false;
        if (result && result.header.status === "200" && result.body) {
          this.addressData = result.body.detail;
        }
        this.panelOpen("IntegratedAddressModalOpen");
      });
    },
    openMissingModal(visitNo, custId) {
      // 是否失聯
      this.missCustId = custId;
      this.subsLoading = true;
      getChangeReprot(this.$store.state.userInfo.id, visitNo).then(result => {
        this.subsLoading = false;
        if (result && result.header.status == "200" && result.body) {
          if (result.body.notice_contact) {
            this.missingContact = result.body.notice_contact.contact;
          } else {
            this.missingContact = "";
          }
          this.panelOpen("MissingModalOpen");
        }
      });
    },
    updateMissing(val) {
      // 更新失聯
      getChangeUpdateReprot(
        this.$store.state.userInfo.id,
        this.missCustId,
        val
      ).then(result => {
        if (result && result.header.status === "200" && result.body) {
          this.setToastMsg(result.header.message);
        } else {
          this.setToastMsg(result.header.message);
        }
        this.panelClose("MissingModalOpen");
        this.initCustList();
      });
    },
    toCustDetail({ custId = "", serNo = "" }) {
      // 導頁至客戶資料
      if (custId !== "") {
        this.updateCustID(custId);
        this.updateSerNo("");
        localStorage.CustID = custId;
        localStorage.SerNo = "";
        this.$router.push({ path: `/detail/CustID/tab/1` });
      } else {
        this.updateSerNo(serNo);
        this.updateCustID("");
        localStorage.CustID = "";
        localStorage.SerNo = serNo;
        this.$router.push({ path: `/detail/SerNo/tab/1` });
      }
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    openInvitationModal() {
      this.panelOpen("InvitationModalOpen");
    },
    CloseInvitation() {
      this.panelClose("InvitationModalOpen");
      // 初始化頁面
      this.initCustList();
    },
    getData(value) {
      getIonlyU(this.$store.state.userInfo.id, value).then(result => {
        this.subsLoading = false;
        if (result.header && result.header.status === "200") {
          this.tableData = result.body.lists.map(item => {
            return {
              name: item.name || "", //客戶姓名
              sex: Number(item.customer_id[1]), //性別
              vip_lv: item.vip_lvl, //顯示VIP
              agnt_id: item.agnt_id || "", //姓名(要保人資料）
              ceapcno: item.customer_id || "", //客戶id
              data_intime: item.data_intime || "", //排程資料進來的時間
              digital_contact_tag: item.digital_contact_tag || "", //數位接觸率標籤
              email: item.email || "",
              email_open_status: this.formatEmail(item.email_open_status) || "", //email發送或開啟的狀態
              email_open_time: item.email_open_time || "", //email發送或開啟的時間
              mobile: item.mobile || "",
              sms_open_status: this.formatMsg(item.sms_open_status) || "", //簡訊發送的狀態
              sms_open_time: item.sms_open_time || "", //簡訊發送的時間
              is_netinsr: item.is_netinsr || "", //網路投保資格
              birthday: item.birthday || "", //生日
              age: item.age || "", //年齡
              memo: item.memo || "", //增齡提醒
              is_exist: item.is_exist || false //判斷是否有客戶資料
            };
          });
          this.allIdData = this.tableData.map(ele => {
            return ele.ceapcno;
          });
          this.distinctid = this.allIdData.filter(function(
            element,
            index,
            arr
          ) {
            return arr.indexOf(element) === index;
          });
          this.tableDataBackup = this.tableData.map(item => {
            let a = moment(item.sms_open_time)
            let b = moment(item.email_open_time)
            if (
              a.diff(b)>0||
              item.email_open_time == ""
            ) {
              item.time = item.sms_open_time;
            } else if (a.diff(b)<0 ||
              item.sms_open_time == ""
            ) {
              item.time = item.email_open_time;
            }else{
              item.time ="";
            }
            return item;
          });
          this.registerHanlink(); // for hard word
        }
      });
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(this.$store.state.userInfo.id, this.categoryInfo.ser_no, this.categoryInfo.upload_file).then(
          result => {
            if (result.type == "application/json") {
              //  json 為檔案下載失敗
              //  把回傳的 blob 轉為 文字檔後再用 json parse
              let reader = new FileReader();
              reader.onload = function() {
                let unicodeJsonA = JSON.parse(reader.result);
                if (unicodeJsonA.header.message) {
                  vm.setToastMsg(unicodeJsonA.header.message);
                } else {
                  vm.setToastMsg("伺服器連線異常");
                }
              };
              reader.readAsText(result);
            } else {
              //  成功取得檔案  進行下載
              saveAs(result, this.categoryInfo.upload_file);
            }
          }
        );
      }
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    }
  },
  mounted() {
    // 初始化頁面
    this.initCustList();

    // 監聽視窗寬度
    const self = this;

    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth > 1220) {
          window.screenWidth = 1220;
          self.screenWidth = 1220;
        } else {
          window.screenWidth = document.body.clientWidth;
          self.screenWidth = window.screenWidth;
        }
      })();
    };

    this.scrollHeight =
      parseInt($(window).height()) - $("tbody").offset().top - 85;
    $(window).bind("resize", function() {
      self.scrollHeight =
        parseInt($(window).height()) - $("tbody").offset().top - 85;
    });
    $(".tab-content").css("padding-bottom", "62px");
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.newTable tbody {
  display: block;
  // height: 552px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
}
</style>
